export default {

    /**
     * NOTE: "hasVideo" is passed as argument because it has logic associated
     * @param {*} groupId 
     * @param {*} sku 
     * @param {*} hasVideo 
     * @param {*} info 
     * @returns 
     */
    getData(groupId, sku, hasVideo, info) {
        if(!info || info.hasOwnProperty('error')){
            return {
                id: groupId,
                sku: sku,
                error: info.error
            }
        }

        return {
            id: groupId,
            sku: sku,
            totalImgs: info.images ? info.images.length : 0,
            hasVideo: hasVideo,
            hasHowItsMade: info.hasOwnProperty('howItsMade'),
        };
    },

    getDataImgClick(groupId, sku, slot){
        return {
            id: groupId,
            sku: sku,
            slot: slot,
        };
    }
};